import React, { useMemo } from 'react';
import SVG from 'react-inlinesvg';
import { components, ControlProps } from 'react-select';
import BaseSelect from '../BaseSelect';
import { BaseSelectWithIconProps } from './BaseSelectWithIcon.types';

const BaseSelectWithIcon: React.FC<BaseSelectWithIconProps> = ({ icon, customComponents, ...baseSelectProps }) => {
  const CustomControl = useMemo(() => {
    return (props: ControlProps): React.ReactElement => {
      const { children, ...controlProps } = props;
      return (
        <components.Control
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...controlProps}
        >
          <SVG className="fill-current w-5 h-5 text-neutral-800 mr-1 flex-shrink-0" src={icon} />
          {children}
        </components.Control>
      );
    };
  }, [icon]);

  return (
    <BaseSelect
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...baseSelectProps}
      customComponents={{
        Control: CustomControl,
        ...customComponents,
      }}
    />
  );
};

export default BaseSelectWithIcon;
